"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralAnalyticsEventType = exports.PaidUserAnalyticsEventType = exports.OnboardingAnalyticsEventType = exports.CURRENT_ANALYTICS_VERSION = void 0;
/*
The intention of the current analytics version is so we have a way of keeping
track of the analytics payloads used at any point in time. If this is file is
ever changed, please update the current analytics version in a commit IMMEDIATELY
following the commit that changes this file, and notify luke.
Can retrieve git hash with: `git rev-parse HEAD`
 */
exports.CURRENT_ANALYTICS_VERSION = '1d60425c0db6b5ebe56715831f10746640a99da5';
var OnboardingAnalyticsEventType;
(function (OnboardingAnalyticsEventType) {
    OnboardingAnalyticsEventType["CREATE_ACCOUNT"] = "CREATE_ACCOUNT";
    OnboardingAnalyticsEventType["CONFIRM_EMAIL"] = "CONFIRM_EMAIL";
    OnboardingAnalyticsEventType["ADD_COURSE_TO_CART"] = "ADD_COURSE_TO_CART";
    OnboardingAnalyticsEventType["PURCHASE_COURSE"] = "PURCHASE_COURSE";
    OnboardingAnalyticsEventType["NEW_DEMO"] = "NEW_DEMO";
    OnboardingAnalyticsEventType["REGISTER_SESSION_DATA"] = "REGISTER_SESSION_DATA";
})(OnboardingAnalyticsEventType || (exports.OnboardingAnalyticsEventType = OnboardingAnalyticsEventType = {}));
var PaidUserAnalyticsEventType;
(function (PaidUserAnalyticsEventType) {
    // Overall
    PaidUserAnalyticsEventType["LOG_IN"] = "LOG_IN";
    PaidUserAnalyticsEventType["LOG_OUT"] = "LOG_OUT";
    PaidUserAnalyticsEventType["LOGGED_IN_HEARTBEAT"] = "LOGGED_IN_HEARTBEAT";
    PaidUserAnalyticsEventType["SUBMIT_REFERRAL_DATA"] = "SUBMIT_REFERRAL_DATA";
    // Content usage
    PaidUserAnalyticsEventType["BEGIN_OUTLINES"] = "BEGIN_OUTLINES";
    PaidUserAnalyticsEventType["STOP_OUTLINES"] = "STOP_OUTLINES";
    PaidUserAnalyticsEventType["OUTLINE_VISITED"] = "OUTLINE_VISITED";
    PaidUserAnalyticsEventType["DOWNLOAD_OUTLINES"] = "DOWNLOAD_OUTLINES";
    PaidUserAnalyticsEventType["DOWNLOAD_FORMULA_SHEET"] = "DOWNLOAD_FORMULA_SHEET";
    PaidUserAnalyticsEventType["OUTLINE_SHOW_PRACTICE_PROBLEM"] = "OUTLINE_SHOW_PRACTICE_PROBLEM";
    PaidUserAnalyticsEventType["BEGIN_NOTECARDS"] = "BEGIN_NOTECARDS";
    PaidUserAnalyticsEventType["STOP_NOTECARDS"] = "STOP_NOTECARDS";
    PaidUserAnalyticsEventType["BEGIN_NOTECARDS_REVIEW"] = "BEGIN_NOTECARDS_REVIEW";
    PaidUserAnalyticsEventType["STOP_NOTECARDS_REVIEW"] = "STOP_NOTECARDS_REVIEW";
    PaidUserAnalyticsEventType["NOTECARD_ATTEMPTED"] = "NOTECARD_ATTEMPTED";
    PaidUserAnalyticsEventType["BUILD_ME_A_DECK"] = "BUILD_ME_A_DECK";
    PaidUserAnalyticsEventType["BUILD_CUSTOM_DECK"] = "BUILD_CUSTOM_DECK";
    PaidUserAnalyticsEventType["NOTECARD_SHOW_HINTS"] = "NOTECARD_SHOW_HINTS";
    PaidUserAnalyticsEventType["NOTECARD_CLICK_TO_OUTLINE"] = "NOTECARD_CLICK_TO_OUTLINE";
    PaidUserAnalyticsEventType["NOTECARD_SHOW_LEARNING_OBJECTIVE"] = "NOTECARD_SHOW_LEARNING_OBJECTIVE";
    PaidUserAnalyticsEventType["NOTECARD_OPEN_MENU"] = "NOTECARD_OPEN_MENU";
    PaidUserAnalyticsEventType["NOTECARD_MNEMONIC_REACTION"] = "NOTECARD_MNEMONIC_REACTION";
    PaidUserAnalyticsEventType["BEGIN_NOTECARD_RECENT_MISTAKES"] = "BEGIN_NOTECARD_RECENT_MISTAKES";
    PaidUserAnalyticsEventType["STOP_NOTECARD_RECENT_MISTAKES"] = "STOP_NOTECARD_RECENT_MISTAKES";
    PaidUserAnalyticsEventType["BEGIN_NOTECARDS_LESSON"] = "BEGIN_NOTECARDS_LESSON";
    PaidUserAnalyticsEventType["STOP_NOTECARDS_LESSON"] = "STOP_NOTECARDS_LESSON";
    PaidUserAnalyticsEventType["COMMENT_STUDENT"] = "COMMENT_STUDENT";
    PaidUserAnalyticsEventType["COMMENT_INSTRUCTOR"] = "COMMENT_INSTRUCTOR";
    PaidUserAnalyticsEventType["COMMENT_ADD_UPVOTE"] = "COMMENT_ADD_UPVOTE";
    PaidUserAnalyticsEventType["COMMENT_REMOVE_UPVOTE"] = "COMMENT_REMOVE_UPVOTE";
    PaidUserAnalyticsEventType["BEGIN_PRACTICE_PROBLEMS"] = "BEGIN_PRACTICE_PROBLEMS";
    PaidUserAnalyticsEventType["STOP_PRACTICE_PROBLEMS"] = "STOP_PRACTICE_PROBLEMS";
    PaidUserAnalyticsEventType["PRACTICE_PROBLEM_ATTEMPTED"] = "PRACTICE_PROBLEM_ATTEMPTED";
    PaidUserAnalyticsEventType["DOWNLOAD_EXCEL_FILE"] = "DOWNLOAD_EXCEL_FILE";
    PaidUserAnalyticsEventType["UPLOAD_EXCEL_FILE"] = "UPLOAD_EXCEL_FILE";
    PaidUserAnalyticsEventType["PRACTICE_PROBLEM_CLICK_TO_OUTLINE"] = "PRACTICE_PROBLEM_CLICK_TO_OUTLINE";
    PaidUserAnalyticsEventType["BUILD_QUIZ"] = "BUILD_QUIZ";
    PaidUserAnalyticsEventType["BUILD_EXAM"] = "BUILD_EXAM";
    PaidUserAnalyticsEventType["GRADE_SINGLE_PROBLEM"] = "GRADE_SINGLE_PROBLEM";
    PaidUserAnalyticsEventType["SUBMIT_PROBLEM_SET"] = "SUBMIT_PROBLEM_SET";
    // Search
    PaidUserAnalyticsEventType["SEARCH_BOX_OPENED"] = "SEARCH_BOX_OPENED";
    PaidUserAnalyticsEventType["SEARCH_RESULT_CLICKED"] = "SEARCH_RESULT_CLICKED";
    PaidUserAnalyticsEventType["SEARCH_BOX_CLOSED"] = "SEARCH_BOX_CLOSED";
    // Content Query
    PaidUserAnalyticsEventType["CONTENT_QUERY_PERFORMED"] = "CONTENT_QUERY_PERFORMED";
    PaidUserAnalyticsEventType["CONTENT_QUERY_RESULT_VIEWED"] = "CONTENT_QUERY_RESULT_VIEWED";
    PaidUserAnalyticsEventType["CONTENT_QUERY_USER_FEEDBACK"] = "CONTENT_QUERY_USER_FEEDBACK";
    PaidUserAnalyticsEventType["CONTENT_QUERY_CANCEL_CLICK"] = "CONTENT_QUERY_CANCEL_CLICK";
    // Grade Practice Problem
    PaidUserAnalyticsEventType["GRADE_PRACTICE_PROBLEM_PERFORMED"] = "GRADE_PRACTICE_PROBLEM_PERFORMED";
    PaidUserAnalyticsEventType["GRADE_PRACTICE_PROBLEM_VIEWED"] = "GRADE_PRACTICE_PROBLEM_VIEWED";
    PaidUserAnalyticsEventType["GRADE_PRACTICE_PROBLEM_FEEDBACK"] = "GRADE_PRACTICE_PROBLEM_FEEDBACK";
    PaidUserAnalyticsEventType["GRADE_PRACTICE_PROBLEM_SCORE_ACCEPTED"] = "GRADE_PRACTICE_PROBLEM_SCORE_ACCEPTED";
    PaidUserAnalyticsEventType["GRADE_PRACTICE_PROBLEM_CANCEL_CLICK"] = "GRADE_PRACTICE_PROBLEM_CANCEL_CLICK";
    PaidUserAnalyticsEventType["GRADE_PRACTICE_PROBLEM_RELEVANT_CONTENT_PATH_CLICK"] = "GRADE_PRACTICE_PROBLEM_RELEVANT_CONTENT_PATH_CLICK";
    // Support
    PaidUserAnalyticsEventType["NEW_SUPPORT_TICKET_OPENED"] = "NEW_SUPPORT_TICKET_OPENED";
    PaidUserAnalyticsEventType["SUPPORT_TICKET_RESPONSE"] = "SUPPORT_TICKET_RESPONSE";
    PaidUserAnalyticsEventType["SUPPORT_TICKET_CLOSED"] = "SUPPORT_TICKET_CLOSED";
    PaidUserAnalyticsEventType["FEEDBACK_SUBMITTED"] = "FEEDBACK_SUBMITTED";
    // Notifications
    PaidUserAnalyticsEventType["OPEN_NOTIFICATIONS_MODAL"] = "OPEN_NOTIFICATIONS_MODAL";
    PaidUserAnalyticsEventType["CLICK_NOTIFICATION"] = "CLICK_NOTIFICATION";
    // Feed
    PaidUserAnalyticsEventType["CLICK_FEED_ITEM"] = "CLICK_FEED_ITEM";
    PaidUserAnalyticsEventType["SCROLL_PAST_INITIAL_FEED"] = "SCROLL_PAST_INITIAL_FEED";
    // Emails
    PaidUserAnalyticsEventType["UNSUBSCRIBE_FROM_EMAILS"] = "UNSUBSCRIBE_FROM_EMAILS";
    PaidUserAnalyticsEventType["SUBSCRIBE_TO_EMAILS"] = "SUBSCRIBE_TO_EMAILS";
    // Study time
    PaidUserAnalyticsEventType["EDIT_STUDY_TIME"] = "EDIT_STUDY_TIME";
    PaidUserAnalyticsEventType["STUDY_TIMER_MANUALLY_PAUSED"] = "STUDY_TIMER_MANUALLY_PAUSED";
    PaidUserAnalyticsEventType["STUDY_TIMER_PAUSED_FROM_INACTIVITY"] = "STUDY_TIMER_PAUSED_FROM_INACTIVITY";
    PaidUserAnalyticsEventType["STUDY_TIMER_MANUALLY_UNPAUSED"] = "STUDY_TIMER_MANUALLY_UNPAUSED";
    // Other features
    PaidUserAnalyticsEventType["CLICK_RECOMMENDED_ACTION"] = "CLICK_RECOMMENDED_ACTION";
    PaidUserAnalyticsEventType["CLICK_PRACTICE_NOTECARDS_FROM_SECTION"] = "CLICK_PRACTICE_NOTECARDS_FROM_SECTION";
    PaidUserAnalyticsEventType["CLICK_PRACTICE_PROBLEMS_FROM_SECTION"] = "CLICK_PRACTICE_PROBLEMS_FROM_SECTION";
    PaidUserAnalyticsEventType["CLICK_ACTION_BUTTON"] = "CLICK_ACTION_BUTTON";
})(PaidUserAnalyticsEventType || (exports.PaidUserAnalyticsEventType = PaidUserAnalyticsEventType = {}));
var GeneralAnalyticsEventType;
(function (GeneralAnalyticsEventType) {
    GeneralAnalyticsEventType["ERROR"] = "ERROR";
    GeneralAnalyticsEventType["ROUTING"] = "ROUTING";
})(GeneralAnalyticsEventType || (exports.GeneralAnalyticsEventType = GeneralAnalyticsEventType = {}));
//# sourceMappingURL=types.js.map